import React from 'react';
import TimelineContainer from '../../Componant/Bonus-Ui/Timeline/Timeline';

const Timeline = () => {
  return (
    <div className='page-body'>
      <TimelineContainer />
    </div>
  );
};

export default Timeline;
